import "whatwg-fetch";

if ($("#locations-top-entry").length) {
  const VAT_PERCENTAGE_CONST = $("#summary").data("vat-percentage");
  const PERMANENT_DISCOUNT =
    100 - ($("#summary").data("permanent-discount") || 0);

  function buildSummary() {
    $(
      "#summary tbody .calculate, #summary tbody .discount, #summary tbody .waitlist"
    ).each(function (index, item) {
      $(item).remove();
    });
    $(
      "#locations-top-entry .tab:not(#recommendationView) input[type=range]"
    ).each(function (index, item) {
      var months = $(item).val() || 0;
      var line = $(item).parents("tr").eq(0);
      if (months > 0) {
        var id = line.attr("data-id");
        var data = line.data("json");
        var type = line.data("type");
        var country_code = line.data("country_code");
        var waitlist = line.data("waitlist");
        var label = window.Translator.trans(
          "top.summary.item",
          { name: data.name || data.zipcode },
          "js"
        );
        var prefix = "geo_ids";
        if (waitlist) {
          label =
            label +
            " " +
            window.Translator.trans(
              "top.summary.waitlist",
              { name: data.name || data.zipcode },
              "js"
            );
          prefix = "geo_ids_waitlist";
        }
        var modelrow = $("#summary .model-row").clone();
        var geo_id = data.zipcode || data.geonameid;
        modelrow
          .addClass("calculate" + (waitlist ? " waitlist" : ""))
          .removeClass("model-row");
        modelrow.attr("id", id);
        modelrow.find(".item .submit-duration").attr({
          name: "top[" + prefix + "][" + geo_id + "][duration]",
          value: months,
        });
        modelrow.find(".item .submit-name").attr({
          name: "top[" + prefix + "][" + geo_id + "][name]",
          value: label,
        });
        modelrow.find(".item .submit-country_code").attr({
          name: "top[" + prefix + "][" + geo_id + "][country_code]",
          value: country_code,
        });
        modelrow.find(".item .submit-type").attr({
          name: "top[" + prefix + "][" + geo_id + "][type]",
          value: type,
        });
        modelrow.find(".item .submit-price").attr({
          name: "top[" + prefix + "][" + geo_id + "][price]",
          value: line.find(".total").attr("data-amount"),
        });
        modelrow.find(".item .name").text(label);
        modelrow
          .find(".discount")
          .text(amountToHuman(line.find(".discount-sum").attr("data-amount")));
        modelrow
          .find(".price")
          .text(months + " x " + amountToHuman(line.data("price")));
        modelrow
          .find(".total")
          .text(amountToHuman(line.find(".total").attr("data-amount")));
        modelrow.attr("data-amount", line.find(".total").attr("data-amount"));
        $("#summary tbody").append(modelrow);
      }
    });

    $("#summary").trigger("recalculate");
  }

  $("#locations-top-entry").on(
    "click",
    ".range-toggler:not(.inactive)",
    function () {
      var line = $(this).parents("tr").eq(0);
      if ($(this).prop("checked") == true) {
        line
          .find("input[type=range]")
          .val(3)
          .removeClass("hidden")
          .trigger("change");
      } else {
        line
          .find("input[type=range]")
          .val(0)
          .addClass("hidden")
          .trigger("change");
      }
    }
  );

  $("#locations-top-entry").on("change", "input[type=range]", function () {
    var months = $(this).val() || 0;
    var id = $(this).parents("tr").eq(0).attr("data-id");
    var lines = $('#locations-top-entry tr[data-id="' + id + '"]');
    var data = $(this).parents("tr").eq(0).data("json");
    if (months > 0) {
      lines.find(".range-toggler:not(.inactive)").prop("checked", true);
      lines.find("input[type=range]").removeClass("hidden");
      lines.addClass("active");
    } else {
      lines.find(".range-toggler:not(.inactive)").prop("checked", false);
      lines.find("input[type=range]").addClass("hidden");
      lines.removeClass("active");
    }

    var discountPercentage = window.Translator.transChoice(
      "top.locations.discount.value",
      months,
      { count: months },
      "js"
    );
    var totalNet = parseFloat(data["final_price"]) * months;
    var discount = (parseFloat(totalNet) * discountPercentage) / 100;
    totalNet = totalNet - discount;

    lines
      .find(".months")
      .text(
        window.Translator.transChoice(
          "top.locations.months",
          months,
          { count: months },
          "js"
        )
      );
    lines
      .find(".discount")
      .text(
        window.Translator.transChoice(
          "top.locations.discount.label",
          months,
          { count: months },
          "js"
        )
      );
    lines
      .find(".discount-sum")
      .text(
        discount == 0
          ? ""
          : amountToHuman(discount + discount * VAT_PERCENTAGE_CONST)
      );
    lines
      .find(".discount-sum")
      .attr("data-amount", discount == 0 ? 0 : discount);
    lines
      .find(".total")
      .text(
        totalNet == 0
          ? ""
          : amountToHuman(totalNet + totalNet * VAT_PERCENTAGE_CONST)
      );
    lines.find(".total").attr("data-amount", totalNet > 0 ? totalNet : 0);
    if ($(this).parents(".tab").attr("id") == "recommendationView") {
      $(
        '#locations-top-entry .tabbox .tab:not(#recommendationView) tr[data-id="' +
          id +
          '"] input[type=range]'
      )
        .val(months)
        .trigger("change");
    } else {
      if (
        $(
          '#locations-top-entry .tabbox .tab#recommendationView  tr[data-id="' +
            id +
            '"]'
        ).length
      ) {
        $(
          '#locations-top-entry .tabbox .tab#recommendationView  tr[data-id="' +
            id +
            '"] input[type=range]'
        ).val(months);
      }
      buildSummary();
    }
  });

  $("#summary").on("recalculate", function () {
    $("#summary tr.discount").remove();
    var entries = $("#summary tr.calculate:not(.hidden)[data-amount]");
    var topEntryCount = $(
      "#summary tr.calculate:not(.hidden):not(.voucher):not(.waitlist)"
    ).length;

    var net = 0;
    var percentDiscount = 0;

    var promotionActivated = true;
    var discounts = [];
    discounts.total = Math.floor(topEntryCount / 3);
    discounts.items = [];

    if (promotionActivated) {
      entries.sort(function discountSort(a, b) {
        return (
          $(a).data("amount") - $(b).data("amount") ||
          $(a).attr("id") - $(a).attr("id")
        );
      });
    }

    entries.each(function (idx, item) {
      // net += $(item).data('amount');
      if ($(item).hasClass("voucher")) {
        if ($(item).attr("data-type") == "VALUE") {
          net -= $(item).data("amount");
        } else if ($(item).data("type") == "PERCENTAGE") {
          percentDiscount = $(item).data("amount");
        }
      } else {
        net += $(item).data("amount");
      }
      if (promotionActivated && !$(item).hasClass("voucher")) {
        if (discounts.total > 0 && discounts.items.length < discounts.total) {
          discounts.items.push(item);
        } else if (discounts.total > 0) {
          discounts.items.forEach(function (discountable) {
            if ($(item).data("amount") < $(discountable).data("amount")) {
              discounts.items.pop(discountable);
              discounts.items.push(item);
            }
          });
        }
      }
    });

    if (promotionActivated) {
      discounts.items.forEach(function (discountable) {
        var discountLine = $(discountable).clone();
        discountLine.addClass("discount");
        discountLine
          .find("span.name")
          .prepend(window.Translator.trans("top.promotion.summary", {}, "js"));
        discountLine
          .find("input.submit-name")
          .val(discountLine.find("span.name").text());
        discountLine
          .find("input.submit-price")
          .val(-discountLine.find("input.submit-price").val());
        discountLine.find("input[type=hidden]").each(function (idx, itm) {
          var newName = $(itm)
            .attr("name")
            .replace("top[geo_ids]", "top[discounts]");
          $(itm).attr("name", newName);
        });
        discountLine.find("td.price").text("");
        discountLine.find("td.discount").text("");
        discountLine.find("td.total").prepend("-");
        net -= $(discountLine).data("amount");
        $(discountLine).insertAfter(discountable);
      });
    }

    if (percentDiscount != 0) {
      var percentDiscountValue = -((net * percentDiscount) / 100);
      $("#summary .voucher:not(.mirror):not(.hidden) td.discount").attr(
        "colspan",
        2
      );
      $("#summary .voucher:not(.mirror):not(.hidden) td.amount").text(
        amountToHuman(percentDiscountValue * 1.0)
      );
      net += percentDiscountValue;
    }

    var vat = VAT_PERCENTAGE_CONST * net;
    var total = vat + net;
    var permanent_discount_amount = total - total * (PERMANENT_DISCOUNT / 100);
    var netHuman = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(net);
    var vatHuman = amountToHuman(vat);
    var totalHuman = amountToHuman(total - permanent_discount_amount);
    var permanentDiscountHuman = amountToHuman(-permanent_discount_amount);
    $("#summary .net").attr("data-amount", net);
    $("#summary .net .amount").text(netHuman);
    $("#summary .vat").attr("data-amount", vat);
    $("#summary .vat .amount").text(vatHuman);
    if (PERMANENT_DISCOUNT > 0) {
      $("#summary .permanent-discount").attr("data-amount", vat);
      $("#summary .permanent-discount .amount").text(permanentDiscountHuman);
    }
    $("#summary .final").attr("data-amount", total);
    $("#summary .final .amount").text(totalHuman);

    if (total == 0) {
      $(".submitter input").val($(".submitter").data("label-free"));
    } else {
      $(".submitter input").val($(".submitter").data("label-costs"));
    }
  });

  if ($(".affix").length) {
    var $affix = $(".affix");
    var $affixParent = $affix.parent();
    var scrollTimeout = null;
    var scrollHandler = function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var scrollTop = $(window).scrollTop();
        if (
          scrollTop > $affixParent.offset().top &&
          scrollTop < $("form[name=newTopEntries]").offset().top - 100
        ) {
          // && scrollTop > $affixParent.parent().offset().bottom
          $affix.addClass("affixed");
        } else {
          $affix.removeClass("affixed");
        }
      }, 50);
    };
    if ($(".affix").is(":visible")) {
      $(window).scroll(scrollHandler);
    } else {
      $(window).off("scroll", scrollHandler);
    }
  }

  $("#locations-top-entry").on(
    "click keyup",
    ".tabs .item.zipcode, #zipcodeView .show-more, .on-page-search",
    function (e) {
      setTimeout(function () {
        $("#zipcodeView table tbody tr:visible").each(function (index, item) {
          var name = $(item).find(".name").text();
          if (name) {
            window
              .fetch("/admin/autocomplete?q=" + name + "&t=zipcode")
              .then((res) => res.json())
              .then(
                (result) => {
                  if (result.length == 1) {
                    $(item)
                      .find(".name")
                      .text(name + " " + result[0].city);
                  } else if (result.length > 1) {
                    result.forEach(function (item, index) {
                      if (index > 0 && result.length > index + 1) {
                        name += ", ";
                      } else if (index > 0) {
                        name +=
                          " " + window.Translator.trans("locale.and", {}, "js");
                      }
                      name += " " + item.city;
                    });
                    $(item).find(".name").text(name);
                  }

                  $(item).find(".name .loader").remove();
                  $(item).find(".name").removeClass("name");
                },
                (error) => {
                  $(item).find(".name .loader").remove();
                  $(item).find(".name").removeClass("name");
                }
              );
          }
        });
      }, 30);
    }
  );
  var onPageSearchTimeout = null;
  var scrollTimeout = null;

  $(".on-page-search").on("keyup change", function () {
    let $this = $(this);
    let v = $this.val();
    clearTimeout(scrollTimeout);
    clearTimeout(onPageSearchTimeout);
    if (v.length > 2) {
      $this.next(".loader").removeClass("hidden");
    }
    onPageSearchTimeout = setTimeout(function () {
      let $table = $this.parents("table").eq(0);
      $table.find(".irrelevant").removeClass("irrelevant");
      $table.find("tbody tr").removeClass("highlighted");
      $table.find(".no-results").addClass("hidden");
      $table.find("tfoot .show-actions").removeClass("hidden");
      if (v.length > 2) {
        $table.find("tbody tr").addClass("irrelevant");
        $table.find(".actions").removeClass("hidden");
        $table.find("tbody tr").removeClass("highlighted");
        $table.find(".no-results").addClass("hidden");
        $table.find("tbody tr").each(function (idx, line) {
          if (
            v.trim() != "" &&
            $(line).find(".item").text().search(new RegExp(v, "gi")) != -1
          ) {
            $(line).addClass("highlighted");
            $(line).removeClass("irrelevant");
          }
        });
        if (!$(".highlighted").length) {
          $table.find(".no-results").removeClass("hidden");
        } else {
          $table.find("tfoot .show-actions").addClass("hidden");
        }
      }
      scrollTimeout = setTimeout(function () {
        $("html, body").animate(
          {
            scrollTop: $("#locations-top-entry").offset().top - 30,
          },
          "slow"
        );
      }, 200);
      $this.next(".loader").addClass("hidden");
    }, 500);
  });
}
